import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { AppData, ModuleData } from '../types/appTypes';
import { checkAdmin, fetchApps, fetchModules } from '../services/api';
import MobileLayout from '../components/layout/MobileLayout';
import WebLayout from '../components/layout/WebLayout';
import { msalInstance } from '../msalInstance';
import { AuthenticationResult } from '@azure/msal-browser';




const HomePage = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [moduleData, setModuleData] = useState<ModuleData[]>([]);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');

    useEffect(() => {
        const init = async () => {
            // Fetch modules
            const data = await fetchModules();
            setModuleData(
                data.content.map((item: any) => ({
                    appId: String(item.appId),
                    appName: item.appName,
                    imageDetail: item.imageDetail
                }))
            );

            if (!isMobile) {
                let emailData = localStorage.getItem('ContactEmail');
                let userEmail = emailData;
                // Initialize MSAL before using it
                if (typeof msalInstance.initialize === 'function') {
                    await msalInstance.initialize();
                }

                let msalEmail: string | undefined;
                let account = msalInstance.getAllAccounts()[0];
                if (!account) {
                    try {
                        const loginResponse = await msalInstance.loginPopup({
                            scopes: ['user.read'],
                        }) as AuthenticationResult;
                        account = loginResponse.account;
                        // Get access token after login
                        if (loginResponse.accessToken) {
                            // console.log('Access Token:', loginResponse.accessToken);
                        }
                    } catch (err) {
                        // Handle login error
                        return;
                    }
                } else {
                    // Try to acquire token silently if already logged in
                    try {
                        const tokenResponse = await msalInstance.acquireTokenSilent({
                            account,
                            scopes: ['user.read'],
                        }) as AuthenticationResult;
                        if (tokenResponse.accessToken) {
                            // console.log('Access Token:', tokenResponse.accessToken);
                        }
                    } catch (err) {
                        // Handle token acquisition error
                    }
                }
                if (account && account.username) {
                    msalEmail = account.username.toLowerCase();
                }

                // Prefer msal email if available, else fallback to localStorage
                userEmail = msalEmail || userEmail || '';
                if (userEmail) {
                    setEmail(userEmail);
                    localStorage.setItem('ContactEmail', userEmail);

                    // After authentication, call checkAdmin
                    const adminResponse = await checkAdmin(userEmail);
                    setIsAdmin(adminResponse.data.isAdmin);
                }
            }
        };

        init();
        // eslint-disable-next-line
    }, [isMobile]);

    return isMobile
        ? <MobileLayout data={moduleData} />
        : <WebLayout data={moduleData} isAdmin={isAdmin} email={email} />;
};

export default HomePage;